/**
 * Briques communes aux maquettes « Trunk SIP ».
 *
 * Le filtre déroulant a été remonté dans `app/common/components/select/FilterSelect`
 * car il est désormais utilisé aussi hors de ce dossier.
 */

export interface InfoRow {
  label: string;
  value: string;
  danger?: boolean;
  link?: boolean;
  onClick?: () => void;
}

/**
 * Liste clé / valeur réutilisant les styles `.info-row` déjà définis pour la
 * page de détail téléphonie (Styles/Telephonie/Style.css).
 */
export const InfoRows = ({rows}: {rows: InfoRow[]}): JSX.Element => (
  <div className="DetailsTelephonie">
    {rows.map((row) => (
      <div className="info-row" key={row.label}>
        <span className="info-label">{row.label}</span>
        <span
          className={`info-value ${row.danger ? 'text-danger' : ''} ${
            row.link ? 'text-primary cursor-pointer' : ''
          }`}
          onClick={row.link ? row.onClick : undefined}
        >
          {row.value || '—'}
        </span>
      </div>
    ))}
  </div>
);

/**
 * Ligne de totaux affichée sous un tableau.
 * `TableMetronic` ne gère pas de pied de tableau : les totaux sont donc rendus
 * à part plutôt que sous forme de ligne triable.
 */
export const TableTotals = ({
  entries,
}: {
  entries: {label: string; value: string}[];
}): JSX.Element => (
  <div className="d-flex flex-wrap gap-6 px-9 pb-6 fw-bold">
    {entries.map((entry) => (
      <span key={entry.label}>
        <span className="text-muted me-2">{entry.label}</span>
        {entry.value}
      </span>
    ))}
  </div>
);
